export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST"
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST"
export const FETCH_ALL = "FETCH_ALL_WISHLIST"
export const WISHLIST_ERROR_MESSAGE = "WISHLIST_ERROR_MESSAGE"
